import React from 'react';
import LinkIcon from '@mui/icons-material/Link';
import SimpleLookupManagement, { LookupField } from './SimpleLookupManagement';

const fields: LookupField[] = [
  {
    key: 'rawText',
    label: 'Raw Import Text',
    required: true,
    helperText: 'Exact farm text as it appears in the source file (matched case-insensitively, scoped to the Business below).',
  },
  {
    key: 'businessId',
    label: 'Business',
    required: true,
    type: 'reference',
    referenceApiPath: '/api/businesses/list',
    displayKey: 'businessName',
  },
  {
    key: 'spatialFeatureId',
    label: 'Farm',
    required: true,
    type: 'reference',
    referenceApiPath: '/api/spatial-features?category=Farm',
    dependsOnKey: 'businessId',
    displayKey: 'spatialFeatureName',
  },
];

// Admin view of FarmAlias — same purpose as ProductAliasManagement, for the
// Farm field instead of Product. Unlike Product/Category/GeneStack/Region,
// this mapping is scoped per Business (see FarmAlias.cs) — the same raw Farm
// name can mean a different real Farm at a different Business — so the Farm
// picker only offers features that belong to the selected Business.
const FarmAliasManagement: React.FC = () => (
  <SimpleLookupManagement
    title="Farm Map"
    icon={<LinkIcon />}
    apiPath="/api/farm-aliases"
    fields={fields}
    entityLabel="Farm Alias"
    softDelete={false}
  />
);

export default FarmAliasManagement;
